import { render, staticRenderFns } from "./OctNotificationMail.vue?vue&type=template&id=a245de4c&"
import script from "./OctNotificationMail.vue?vue&type=script&lang=js&"
export * from "./OctNotificationMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports